import Router from '@alltrails/shared/components/ReactRouter';
import { Context } from '@alltrails/shared/types/context';
import ApplicationLayout from 'components/ApplicationLayout/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import PlusLandingPage from 'components/PlusLandingPage';
import { Route, Switch } from '@alltrails/shared/components/ReactRouter';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import PaymentMethod from 'types/PaymentType';
import Plan from 'types/Plan';
import CheckoutRoute from './CheckoutRoute';
import LoginRoute from './LoginRoute';
import RegisterRoute from './RegisterRoute';

type ProRouterProps = {
  annualPlan: Plan;
  context: Context;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  currentPage: string;
  locationSlug: string;
  paymentTypes?: PaymentMethod[];
  planTypes: Plan[];
  recurlyPublicKey: string;
  userId?: number;
  wideFooter: boolean;
};

function ProRouter({
  currencyCode,
  recurlyPublicKey,
  coupon,
  annualPlan,
  planTypes,
  userId,
  currentPage,
  locationSlug,
  context,
  wideFooter
}: ProRouterProps) {
  return (
    <Router fullpath={global.__AT_DATA__.pathname}>
      <Switch>
        <Route path="/:locale?/signup">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <RegisterRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/login">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <LoginRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/pro">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <PlusLandingPage coupon={coupon} currencyCode={currencyCode} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/pro/checkout">
          <CheckoutRoute
            annualPlan={annualPlan}
            coupon={coupon}
            currencyCode={currencyCode}
            plans={planTypes}
            recurlyPublicKey={recurlyPublicKey}
            userId={userId}
          />
        </Route>
        <Route exact path="/:locale?/plus">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <PlusLandingPage coupon={coupon} currencyCode={currencyCode} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/plus/checkout">
          <CheckoutRoute
            annualPlan={annualPlan}
            coupon={coupon}
            currencyCode={currencyCode}
            plans={planTypes}
            recurlyPublicKey={recurlyPublicKey}
            userId={userId}
          />
        </Route>
      </Switch>
    </Router>
  );
}

type Props = {
  annualPlan: Plan;
  // layout props
  context: Context;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  currentPage: string;
  locationSlug: string;
  paymentTypes?: PaymentMethod[];
  planTypes: Plan[];
  recurlyPublicKey: string;
  userId?: number;
  wideFooter: boolean;
};

export default function Pro({
  context,
  planTypes,
  paymentTypes,
  currencyCode,
  coupon,
  recurlyPublicKey,
  annualPlan,
  userId,
  wideFooter,
  currentPage,
  locationSlug
}: Props) {
  return (
    <CustomProvider>
      <ProRouter
        annualPlan={annualPlan}
        context={context}
        coupon={coupon}
        currencyCode={currencyCode}
        currentPage={currentPage}
        locationSlug={locationSlug}
        paymentTypes={paymentTypes}
        planTypes={planTypes}
        recurlyPublicKey={recurlyPublicKey}
        userId={userId}
        wideFooter={wideFooter}
      />
    </CustomProvider>
  );
}
